export default __webpack_public_path__ + "static/media/celo-safe.0b34b9b7.svg";